import ReactDOM from 'react-dom/client';
import './index.css';
import './globals.css';
import App from './App';
import { BrowserRouter} from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { QueryClient, QueryClientProvider } from 'react-query';
import { QueryClient as QC, QueryClientProvider as QCP } from '@tanstack/react-query';


import './i18n'
import { store, persistor } from './store';
import { AuthProvider } from './context/AuthProvider';
import { Suspense } from 'react';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);
export const queryClient = new QueryClient()
const qC = new QC()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const basename = document.querySelector('base')?.getAttribute('href') ?? '/'    

root.render(
  <Provider store={store}>
    <Suspense>
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <QCP client={qC}>
          <QueryClientProvider client={queryClient}>
            <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter basename={basename}>
              <App />
            </BrowserRouter>
            </PersistGate>
          </QueryClientProvider>
        </QCP>
      </AuthProvider>
    </MsalProvider>
    </Suspense>
  </Provider>
);